import { useEffect, useState } from 'react';

/**
 * Hook for using a value on a debounced timer, eg using a search field value
 * to trigger an api request, but only when a user stops typing.
 * @param {any} value The value to track at the provided interval.
 * @param {number} [delay] Optional delay length (in milliseconds). Default is 300.
 * @returns The debounced value
 */
export function useDebouncedValue<T = any>(value: T, delay = 300) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
